module.exports = __webpack_public_path__ + "static/img/spot1.d4ecf35.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/spot1.png
// module id = PA1K
// module chunks = 1